module.exports = __webpack_public_path__ + "static/img/client5_comment.5d4b853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client5_comment.png
// module id = x2d5
// module chunks = 1